import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Splash from '../../../splash/Splash';



const FeatureGames = ({slidersFeatures}) => {
 
        const [isLoading, setIsLoading] = useState(false);
      const [isLoggedIn] = useState(!!localStorage.getItem('token'));
      const [isMobile] = useState(false);
      const navigate = useNavigate();
      const [error, setError] = useState(null);
      const origin = window.location.origin;

    // Fetch games data
   
    
        const handleGameClick = async (gameCode) => {
                if (!isLoggedIn) {
                    navigate('/login');
                    return;
                }
                setIsLoading(true);

                try {
                    const token = localStorage.getItem('token');
                    const remote_id = localStorage.getItem('remote_id');
                    if (!token || !remote_id) {
                        setError('User not logged in');
                        return;
                    }

                    // If link is a full URL, navigate directly to gamerun iframe
                    if (typeof gameCode === 'string' && /^https?:\/\//i.test(gameCode)) {
                        navigate('/gamerun', { state: { iframeUrl: gameCode } });
                        return;
                    }

                    // Derive platform/type from shorthand code when needed
                    let platform;
                    let gameType;
                    if (typeof gameCode === 'string' && gameCode.includes('-')) {
                        const parts = gameCode.split('-');
                        platform = parts[0];
                        gameType = parts[1];
                    }

                    // Special case: Lucky/LuckySport may require player-login
                    if (platform === 'Lucky' || platform === 'LuckySport') {
                        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/player-login`, {
                            method: 'POST',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`,
                            },
                            body: JSON.stringify({ user_id: remote_id }),
                        });
                        const dataly = await res.json();
                        if (dataly?.access_token) {
                            navigate('/gamerun', { state: { iframeUrl: `https://sprodm.uni247.xyz/?access_token=${dataly.access_token}` } });
                            return;
                        }
                    }

                    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/inr-game-run`, {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`,
                        },
                        body: JSON.stringify({
                            userId: remote_id,
                            externalURL: origin,
                            isMobileLogin: window.innerWidth <= 768,
                            gameCode,
                            gameType,
                            platform,
                        }),
                    });

                    const data = await response.json();
                    if (response.ok) {
                        const iframeUrl = data?.url || data?.data?.payload?.game_launch_url;
                        if (iframeUrl) {
                            navigate('/gamerun', { state: { iframeUrl } });
                        } else {
                            setError(data.message || 'Missing game URL in response');
                        }
                    } else {
                        setError(data.message || 'An unexpected error occurred');
                    }
                } catch (error) {
                    setError('An unexpected error occurred');
                } finally {
                    setIsLoading(false);
                }
            };
      if(isLoading) {
        return(
         <Splash/>
        );
      }

    return (
        
            <div className="recommend feature-games">
                <div className="recommend-title">
                    <h2>Featured Games</h2>
                </div>
                <div className="recommend-bg games">
                    <div className="recommend-main games-main">
                        {slidersFeatures.length > 0 ? (
                            slidersFeatures.map((game, index) => (
                                <div onClick={() => handleGameClick(game.link)} className="games-box" key={index}>
                                    <div className="pic">
                                        <Link>
                                            <img 
                                                alt={game.name} 
                                                src={`${process.env.REACT_APP_API_URL}/storage/${game.thubmnail}`} 
                                                loading="lazy" 
                                            />
                                        </Link>
                                    </div>
                                    <div className="text">
                                        <h3>{game.name}</h3>
                                        <input type='hidden' value={error}/>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p></p>
                        )}
                    </div>
                </div>
            </div>
        
    );
};

export default FeatureGames;
